/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Tab_MediaInputs */

const cs_property_tab_media = /** @type {(inputs: Property_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografie & Média`)
};

const en_property_tab_media = /** @type {(inputs: Property_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos & Media`)
};

/**
* | output |
* | --- |
* | "Photos & Media" |
*
* @param {Property_Tab_MediaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_tab_media = /** @type {((inputs?: Property_Tab_MediaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Tab_MediaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_tab_media(inputs)
	return cs_property_tab_media(inputs)
});